/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online area chart maker. Paste your data to get an instant, colourful filled-area chart that emphasises volume and trends.`)
};

const es_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de área online. Pega tus datos para obtener un gráfico de área rellena instantáneo y colorido que resalta el volumen y las tendencias.`)
};

const de_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Flächendiagramm-Ersteller. Fügen Sie Ihre Daten ein und erhalten Sie sofort ein farbenfrohes gefülltes Flächendiagramm, das das Volumen und Trends betont.`)
};

const nl_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online vlakdiagrammaker. Plak je data om direct een kleurrijk gevuld vlakdiagram te krijgen dat volume en trends benadrukt.`)
};

const fr_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de graphique en aires en ligne. Collez vos données pour obtenir instantanément un graphique en aires colorées qui met en valeur le volume et les tendances.`)
};

const it_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici ad area online. Incolla i tuoi dati per ottenere un grafico ad area riempita istantaneo e colorato che mette in evidenza volume e tendenze.`)
};

const pt_br2_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de área. Cole seus dados para obter um gráfico de área preenchida instantâneo e colorido que enfatiza volume e tendências.`)
};

const pt_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de área online. Cole os seus dados e obtenha instantaneamente um gráfico de área preenchida colorido que realça o volume e as tendências.`)
};

const ja_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインエリアチャート作成ツール。データを貼り付けると、量と傾向を強調する見やすい塗りつぶしエリアチャートが即座に得られます。`)
};

const zh_area_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线面积图制作工具。粘贴数据即可获得即时的多彩填充面积图，突出显示数量与趋势。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_meta_description", locale)
	if (locale === "en") return en_area_meta_description(inputs)
	if (locale === "es") return es_area_meta_description(inputs)
	if (locale === "de") return de_area_meta_description(inputs)
	if (locale === "nl") return nl_area_meta_description(inputs)
	if (locale === "fr") return fr_area_meta_description(inputs)
	if (locale === "it") return it_area_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_area_meta_description(inputs)
	if (locale === "pt") return pt_area_meta_description(inputs)
	if (locale === "ja") return ja_area_meta_description(inputs)
	return zh_area_meta_description(inputs)
};